export interface IReportAutoRunLocationState {
  reportAutoRunParams?: Record<string, unknown>;
}

export function getPresetReportAutoRunParams(
  state: unknown,
): Record<string, unknown> | undefined {
  if (state == null || typeof state !== "object") {
    return undefined;
  }

  const params = (state as IReportAutoRunLocationState).reportAutoRunParams;

  if (params == null || typeof params !== "object") {
    return undefined;
  }

  return params;
}
